// src/common/UpdateStatusModal.jsx

import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { closeModal } from "../redux/features/modalSlice";
import Swal from "sweetalert2";
function UpdateStatusModal({
  title,
  statusFunction,
  id,
  currentStatus,
  statusOptions = [],
  onSubmit,
  role
}) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
 const isAdmin = role === "admin";
  const [formData, setFormData] = useState({
    status: currentStatus || "",
    remarks: "",
    followup_date: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleSubmit = async () => {
    try {
      setLoading(true);
      const payload = {
        id,
        status: formData.status,
        remarks: formData.remarks,
        followup_date: formData.followup_date,
      };
 const res=await onSubmit(payload);

     
      const message =
      res?.message || "Status Updated Successfully";

    Swal.fire({
      icon: "success",
      title: "Success",
      text: message,
      timer: 2000,
      showConfirmButton: false,
    });

      dispatch(closeModal());
    } catch (error) {
      console.log(error);
       const errMsg =
      error?.response?.data?.message ||
      error?.message ||
      "Status Update Failed";

    Swal.fire({
      icon: "error",
      title: "Error",
      text: errMsg,
    });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="custom-modal-body">

        <h4 className="mb-4 text-center">
          {title}
        </h4>

        {/* STATUS */}
        <div className="mb-3">
          <label>Status</label>

          <select
            className="form-select"
            name="status"
            value={formData.status}
            onChange={handleChange}
          >
            <option value="">Select Status</option>

            {statusOptions.map((item) => (
              <option key={item.value} value={item.value}>
                {item.label || item.value}
              </option>
            ))}
          </select>
        </div>

        {/* REMARK */}
        <div className="mb-3">
          <label>Remark</label>

          <textarea
            className="form-control"
            rows="4"
            name="remarks"
            value={formData.remarks}
            onChange={handleChange}
            placeholder="Enter remark..."
          />
        </div>

        {/* FOLLOWUP DATE */}
        <div className="mb-3">
          <label>Followup Date</label>

          <input
            type="date"
            className="form-control"
            name="followup_date"
            value={formData.followup_date}
            onChange={handleChange}
          />
        </div>

      </div>

      <div className="modal-btn-group justify-content-center">

        <button
          className="cancel-btn"
          onClick={() => dispatch(closeModal())}
        >
          Cancel
        </button>

        <button
          className="save-btn"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Updating..." : "Update Status"}
        </button>

      </div>
    </>
  );
}

export default UpdateStatusModal;